import { axiosHelper } from 'Services/AxiosHelper';
import { OnConfirmSmsModel, onGetAgreementContentModel } from 'Models';
import { onGetAgreementContentReqBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.OnGetAgreementContent';

const onGetAgreementContent = async (params: onGetAgreementContentReqBodyData): Promise<onGetAgreementContentModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default onGetAgreementContent;
